import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const winnerWrapper = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space.xs,
});
